import { Injectable } from '@angular/core';
import { config } from '../config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RateDerivativesService {
  config = config;
  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  constructor(
    private http: HttpClient
  ) { }

  submitIRS(requestObject) {
    let URL = environment.URL + this.config.URL.submitIRS;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getIrsTrades(requestObject) {
    let URL = environment.URL + this.config.URL.getIrsTrades;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getIrsTradeById(irsTradeId) {
    let URL = environment.URL + this.config.URL.getIrsTradeData + '/' + irsTradeId;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getAmrtAcrtSchedule(requestObject) {
    let URL = environment.URL + this.config.URL.getAmrtAcrtSchedule;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getPaymentSchedule(requestObject) {
    let URL = environment.URL + this.config.URL.getPaymentSchedule;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  saveIRSAsDraft(requestObject) {
    let URL = environment.URL + this.config.URL.saveIRSAsDraft;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, requestObject, this.options);
  }

  getDraftIrsTrades() {
    let URL = environment.URL + this.config.URL.getDraftIrsTrades;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getDraftIrsTradeById(id) {
    let URL = environment.URL + this.config.URL.getDraftIrsTradeById + '/' + id;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  cancelIRSTrade(id){
    let URL = environment.URL + this.config.URL.cancelIRSTrade + '/' + id;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  removeDraftIrsTrade(id){
    let URL = environment.URL + this.config.URL.removeDraftIrsTrade + '/' + id;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getCurrencyBenchmarkRates(){
    let URL = environment.URL + this.config.URL.getCurrencyBenchmarkRates;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  getirsTradeDataChart(entityCode:any) {
     let URL = environment.URL + this.config.URL.getDailyIRSTradeData+'/'+entityCode;
     return this.http.get(URL);

  }
}
